import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../../core/api/authService";

const Signin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("dcms_token");
    if (token) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) { setError("Username and password are required."); return; }
    setError("");
    setLoading(true);
    try {
      const res = await login({ username, password });
      const token = res.data?.token || res.data?.accessToken;
      if (!token) throw new Error("No token in response");
      localStorage.setItem("dcms_token", token);
      if (res.data?.user) localStorage.setItem("dcms_user", JSON.stringify(res.data.user));
      else localStorage.removeItem("dcms_user");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      const d = err.response?.data;
      const msg = d?.message || d?.title || (typeof d === "string" ? d : null) || "Invalid username or password.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      width: "100%",
      backgroundImage: "url(/assets/img/authentication/login-bg.jpg)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: "0 6vw",
    }}>
      <div style={{
        width: "100%",
        maxWidth: 350,
        // background: "rgba(230, 214, 214, 0.88)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderRadius: 18,
        padding: "30px 30px 46px",
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
        marginLeft: "10vw",
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 28 }}>
          <img
            src="/assets/img/logo3.png"
            alt="Logo"
            style={{ maxHeight: 52, maxWidth: 220, objectFit: "contain" }}
          />
        </div>

        {/* Heading */}
        <h2 style={{ fontWeight: 700, fontSize: 26, marginBottom: 24, color: "#1a1a2e" }}>
          Sign In
        </h2>

        {error && (
          <div style={{
            background: "#fff0f0", border: "1px solid #ffcccc",
            borderRadius: 8, padding: "10px 14px", marginBottom: 16,
            color: "#c0392b", fontSize: 14,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Username */}
          <div style={{ marginBottom: 18 }}>
            <label style={{ display: "block", marginBottom: 6, fontWeight: 500, fontSize: 14, color: "#444" }}>
              User Name
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              placeholder="Enter your username"
              style={{
                width: "100%", padding: "11px 14px", borderRadius: 8,
                border: "1.5px solid #dde1e7", fontSize: 15,
                background: "#f7f8fa", outline: "none", boxSizing: "border-box",
              }}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: 28 }}>
            <label style={{ display: "block", marginBottom: 6, fontWeight: 500, fontSize: 14, color: "#444" }}>
              Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                placeholder="Enter your password"
                style={{
                  width: "100%", padding: "11px 44px 11px 14px", borderRadius: 8,
                  border: "1.5px solid #dde1e7", fontSize: 15,
                  background: "#f7f8fa", outline: "none", boxSizing: "border-box",
                }}
              />
              <span
                onClick={() => setShowPassword((v) => !v)}
                style={{
                  position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)",
                  cursor: "pointer", color: "#888", fontSize: 16,
                }}
              >
                <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`} />
              </span>
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%", padding: "12px", borderRadius: 8, border: "none",
              background: loading ? "#f0a070" : "#FF6B35",
              color: "#fff", fontWeight: 700, fontSize: 16,
              cursor: loading ? "not-allowed" : "pointer",
              letterSpacing: 0.5, transition: "background 0.2s",
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        {/* Copyright */}
        <p style={{ textAlign: "center", marginTop: 32, fontSize: 14, color: "#4b4b4b", marginBottom: 0 }}>
          Copyright © 2026 Axobis. All rights reserved
        </p>
      </div>
    </div>
  );
};

export default Signin;
